import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = {
  key: 0,
  class: "col-sm-6 mb-25"
}
const _hoisted_4 = {
  key: 0,
  class: "col-xxl-6 col-xxxl-6"
}
const _hoisted_5 = {
  key: 1,
  class: "col-12"
}
const _hoisted_6 = {
  key: 2,
  class: "row"
}
const _hoisted_7 = { class: "col-sm-6 mb-25" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FKBreadCrumb = _resolveComponent("FKBreadCrumb")!
  const _component_UserSummary = _resolveComponent("UserSummary")!
  const _component_CreatePatientCard = _resolveComponent("CreatePatientCard")!
  const _component_ProfileCenterCard = _resolveComponent("ProfileCenterCard")!
  const _component_PatientCancellationCarousel = _resolveComponent("PatientCancellationCarousel")!
  const _component_EventsCalendar = _resolveComponent("EventsCalendar")!
  const _component_PatientsList = _resolveComponent("PatientsList")!
  const _component_QuickLook = _resolveComponent("QuickLook")!
  const _component_InviteUserCard = _resolveComponent("InviteUserCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FKBreadCrumb, {
      page: _ctx.$t('page.home')
    }, null, 8 /* PROPS */, ["page"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.indexPermission ? ['col-xxl-6', 'col-xxxl-6'] : ['col-12'])
      }, [
        _createVNode(_component_UserSummary),
        (!_ctx.isAdmin && !_ctx.isInternal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.createPermission)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_CreatePatientCard)
                  ]))
                : _createCommentVNode("v-if", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enabledCenters, (center) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-sm-6 mb-25",
                  key: center.id
                }, [
                  _createVNode(_component_ProfileCenterCard, { center: center }, null, 8 /* PROPS */, ["center"])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.indexPermission)
          ? (_openBlock(), _createBlock(_component_PatientCancellationCarousel, { key: 1 }))
          : _createCommentVNode("v-if", true),
        ((!_ctx.isAdmin && !_ctx.isInternal) && _ctx.config.feature.messages)
          ? (_openBlock(), _createBlock(_component_EventsCalendar, { key: 2 }))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      (_ctx.indexPermission)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_PatientsList, { enableAddPatient: false })
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isAdmin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_QuickLook)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isInternal && _ctx.assignment_strategy === 'by_hcp')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_InviteUserCard)
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}